// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"191":"183a1519","902":"2af058dc"}[chunkId] + ".chunk.css";
};